export const items = [
    {
      id: "a",
      category: "Sports nutrition",
      title: "Mofito",
      pointOfInterest: 260,
      backgroundColor: "#5DBCD2",
      ciel: 'https://www.mofito.eu/',
      description: "Mnohí športovci si prešli obdobím, keď napriek poctivému tréningu neboli schopní podať taký výkon na aký majú natrénované, nevládzu alebo nemajú takú rýchlosť akú mali na tréningu. Je to aj váš prípad? Potom vás môže zaujímať nasledovné: Môže to mať viacero príčin ako nesprávny tréning, mentálna príprava a neposlednom rade je to nesprávna výživa. S posledným bodom Vám ľahko a rýchlo môžeme pomôcť! Od toho je tu tím Mofito a práve pre Vás, športovcov, ktorí chcú podať nielen pri zápase maximálny výkon, sme s odborníkmi zostavili ucelený balíček výživových doplnkov."
    },
    {
      id: "c",
      category: "Travel",
      title: "UNIGLOBE TWU Travel",
      pointOfInterest: 250,
      backgroundColor: "#814A0E",
      ciel: 'https://www.uniglobetwutravel.sk/',
      description: "Venujte sa Vašej prosperite. Vy si hľadáte, dohadujete a realizujete Váš biznis. My Vám profesionálne zabezpečíme cestu k nemu.UNIGLOBE® TWU Travel je obchodná značka cestovnej kancelárie TWU, s.r.o., ktorá má v Slovenskej republike licenčné zastúpenie nadnárodnej spoločnosti UNIGLOBE® Travel (International) so sídlom vo Vancouveri v Kanade. Jedná sa o najväčšiu licenčnú cestovnú agentúru na svete, s viac ako 750  zastúpeniami vo viac ako 65 krajinách sveta.",
    },
    {
      id: "f",
      category: "Travel",
      title: "Plavby po riekach",
      pointOfInterest: 120,
      backgroundColor: "#959684",
      ciel: 'http://www.plavbyporiekach.sk/',
      description: "Plavby loďou sú voľný čas, relaxácia a odpočinok na palube 5 * lode. Jedná sa o nevšedný zážitok ponúkajúce cestovanie, možnosť prehliadky miest, degustácia vína, gurmánske špeciality, návštevy pamiatok a nezabudnuteľné zážitky. Pre relaxáciu sa na palube nachádza wellness, sauna, kozmetický salón a vírivka. Počas plavby je strava all inclusive, ktorá zahŕňa miešané nápoje, nealkoholické nápoje a káva. Pre lode sú typické významné európske rieky a môžete si vybrať: plavba po Dunaji, plavba po Rýne a Meuse ale aj Rhôna, Saône Seina. Počas plavby tak môžete navštíviť európske metropoly, ako sú Viedeň, Budapešť, Amsterdam, Rotterdam. Vo Francúzsku navštívite oblasť Provence, na Dunaji zase Dunajskej katarakty. Riečna plavba je bezpečná dovolenka, ideálne svadobná cesta či medové týždne, originálny darček, romantika pre manželské páry, zamilované páry, ale aj firemné akcie. Spoločnosť TWU, s.r.o. je provízny predajca A-ROSA."
    },
    // {
    //   id: "g",
    //   category: "Marketing place",
    //   title: "Ochranný Balíček",
    //   pointOfInterest: 200,
    //   backgroundColor: "#8F986D",
    //   ciel: 'https://www.ochrannybalicek.sk/',
    //   description: "Ukáž sa a chráň! Ochranný balíček, okrem primárnej ochrany zdravia nesie so sebou aj silný marketingovo – informačný priestor na jeho vrchnom obale. Tento obal je v plnej miere individualizovaný podľa Vášho zadania. V tejto podobe môžete balíček využiť na prezentáciu Vašej spoločnosti, prípadne Vašich partnerov a taktiež ako nositeľ organizačných pokynov a iných informácií."
    // }
  ];
  
  export const openSpring = { type: "spring", stiffness: 200, damping: 30 };
  